module.exports = __webpack_public_path__ + "img/1-insurance-zone-walkthrough.802d0c7e.jpg";